
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/pistenplan",
      function () {
        return require("private-next-pages/[region]/[resort]/pistenplan.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/pistenplan"])
      });
    }
  